/* @flow */

export const topBarHeight = 44;
